import React from "react";
import { useLocation } from "react-router-dom";

const VoidCheck = () => {
  const location = useLocation();
  let { ticketData, type } = location.state;

  let passengerNames = [];
  let status = [];
  if (type === "manual") {
    if (Array.isArray(ticketData)) {
      ticketData.map((passengerData) => {
        if (passengerData?.BookingTraveler instanceof Array) {
          passengerData?.BookingTraveler?.map((passenger) =>
            passengerNames.push
              ? passengerNames.push(passenger?.BookingTravelerName?._attributes)
              : passengerNames.push(passenger?.BookingTravelerName?._attributes)
          );
        } else {
          passengerNames.push(
            passengerData?.BookingTraveler?.BookingTravelerName?._attributes
          );
        }
        status.push(
          passengerData?.Ticket?.[0]?._attributes?.TicketStatus ||
            passengerData?.Ticket?._attributes?.TicketStatus
        );
      });
    } else {
      if (ticketData?.BookingTraveler instanceof Array) {
        ticketData?.BookingTraveler?.map((passenger) => {
          passengerNames.push
            ? passengerNames.push(passenger?.BookingTravelerName?._attributes)
            : passengerNames.push(passenger?.BookingTravelerName?._attributes);
        });
      } else {
        passengerNames.push(
          ticketData?.BookingTraveler?.BookingTravelerName?._attributes
        );
      }
      status.push(
        ticketData?.Ticket?.[0]?._attributes?.TicketStatus ||
          ticketData?.Ticket?._attributes?.TicketStatus
      );
    }
  } else {
    if (ticketData?.BookingTraveler instanceof Array) {
      ticketData?.BookingTraveler?.map((passenger) => {
        passengerNames.push
          ? passengerNames.push(passenger?.BookingTravelerName?._attributes)
          : passengerNames.push(passenger?.BookingTravelerName?._attributes);
      });
    } else {
      passengerNames.push(
        ticketData?.BookingTraveler?.BookingTravelerName?._attributes
      );
    }

    if (ticketData?.AirReservation?.DocumentInfo?.TicketInfo.length) {
      status = ticketData?.AirReservation?.DocumentInfo?.TicketInfo.map(
        (ticket) => {
          return ticket?._attributes?.Status;
        }
      );
    } else {
      status.push(
        ticketData?.AirReservation?.DocumentInfo?.TicketInfo?._attributes
          ?.Status
      );
    }
  }

  return (
    <div className="">
      <div className="flex flex-col items-center sm:flex-row">
        <div className="py-4 mx-4 mt-4 sm:mx-20">
          <div className="flex flex-col p-2 ml-4 space-y-3 w-60 text-black rounded-lg border-black sm:ml-20 border-1">
            <h1 className="mb-1 text-lg font-semibold">Legends</h1>
            <div class="flex items-center">
              <p class="ml-2">T - Ticketed</p>
            </div>

            <div class="flex items-center mt-2 space-y-3">
              <p class="ml-2">V - Void</p>
            </div>

            <div class="flex items-center mt-2 space-y-3">
              <p class="ml-2">R- Refunded</p>
            </div>

            <div class="flex items-center mt-2 space-y-3">
              <p class="ml-2">N - Unused</p>
            </div>

            <div class="flex items-center mt-2 space-y-3">
              <p class="ml-2">X - Exchanged</p>
            </div>

            <div class="flex items-center mt-2 space-y-3">
              <p class="ml-2">P - Partially Refunded</p>
            </div>

            <div class="flex items-center mt-2 space-y-3">
              <p class="ml-2">S/F - Used</p>
            </div>
          </div>
        </div>

        <div className="w-full md:mx-10">
          <div className="flex flex-row justify-between">
            <h2 className="p-2 text-2xl font-semibold text-black">
              Ticket Status Checker
            </h2>
            <div className="">
              <button
                className="px-4 py-2 font-bold text-white bg-red-500 rounded-lg hover:bg-red-600"
                onClick={() => window.history.back()}
              >
                Go Back
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="table mb-4 text-gray-700 card-table default-table display dataTablesCard dataTable no-footer"
              id="example5"
              role="grid"
              aria-describedby="example5_info"
            >
              <thead>
                <tr role="row">
                  <th className="bg-none sorting_asc">
                    <p>#</p>
                  </th>
                  <th className="sorting">Passenger Name</th>
                  <th className="sorting">Status</th>
                </tr>
              </thead>
              <tbody>
                {passengerNames?.map((passenger, index) => (
                  <tr role="row" key={index}>
                    <td>
                      <div className="flex flex-row gap-2">
                        <div>{++index}</div>
                      </div>
                    </td>
                    <td>
                      <div className="text-sm font-semibold text-black capitalize">
                        {passenger?.First} {passenger?.Last}
                      </div>
                    </td>
                    <td>
                      <div className="px-2 py-1 text-xs font-semibold text-center text-white bg-green-500 rounded-full badge badge-success">
                        {status[index - 1]}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoidCheck;
